import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Ultraship_ds_get_load_containers_by_project_and_filtersService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { projectLookupCode?: string }): 
  Promise<{ result: { Id?: number, AvailableDate?: string, CallOutDate?: string, CheckOutDate?: string, ContainerSize?: string, InYardDate?: string, LastPierDate?: string, StatusId?: number, OrderType?: { Name?: string }, Status?: { Name?: string }, Carrier?: { Name?: string, ScacCode?: string, ShortName?: string }, CarrierServiceType?: { Name?: string, ShortName?: string }, Shipments?: { Id?: number, AvailableDate?: string, DockDate?: string, LookupCode?: string, Priority?: number, OrderLookups?: { OrderId?: number, ShipmentId?: number, Order?: { AccountId?: number, BillingAddresId?: number, LookupCode?: string, OrderClassId?: number, OwnerReference?: string, VendorReference?: string, Project?: { Id?: number, LookupCode?: string } } }[] }[] }[] }> 
  {
    let url = `${environment.backendUrl}api/Ultraship/datasources/ds_get_load_containers_by_project_and_filters/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { projectLookupCode?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, AvailableDate?: string, CallOutDate?: string, CheckOutDate?: string, ContainerSize?: string, InYardDate?: string, LastPierDate?: string, StatusId?: number, OrderType?: { Name?: string }, Status?: { Name?: string }, Carrier?: { Name?: string, ScacCode?: string, ShortName?: string }, CarrierServiceType?: { Name?: string, ShortName?: string }, Shipments?: { Id?: number, AvailableDate?: string, DockDate?: string, LookupCode?: string, Priority?: number, OrderLookups?: { OrderId?: number, ShipmentId?: number, Order?: { AccountId?: number, BillingAddresId?: number, LookupCode?: string, OrderClassId?: number, OwnerReference?: string, VendorReference?: string, Project?: { Id?: number, LookupCode?: string } } }[] }[] }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Ultraship/datasources/ds_get_load_containers_by_project_and_filters/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { projectLookupCode?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, AvailableDate?: string, CallOutDate?: string, CheckOutDate?: string, ContainerSize?: string, InYardDate?: string, LastPierDate?: string, StatusId?: number, OrderType?: { Name?: string }, Status?: { Name?: string }, Carrier?: { Name?: string, ScacCode?: string, ShortName?: string }, CarrierServiceType?: { Name?: string, ShortName?: string }, Shipments?: { Id?: number, AvailableDate?: string, DockDate?: string, LookupCode?: string, Priority?: number, OrderLookups?: { OrderId?: number, ShipmentId?: number, Order?: { AccountId?: number, BillingAddresId?: number, LookupCode?: string, OrderClassId?: number, OwnerReference?: string, VendorReference?: string, Project?: { Id?: number, LookupCode?: string } } }[] }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Ultraship/datasources/ds_get_load_containers_by_project_and_filters/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
